import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Modal, Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';

const RuleGroup = () => {
  const dispatch = useDispatch();
  const { rule_group_id } = useParams();
  const { ruleGroup, loadingRuleGroup, rules } = useSelector((state) => state.general);

  const [open, setOpen] = useState(false);

  const [name, setName] = useState('');
  const [ruleIds, setRuleIds] = useState([]);
  const [blockRuns, setBlockRuns] = useState(false);
  const [selectedRules, setSelectedRules] = useState([]);
  const [selectedAddRules, setSelectedAddRules] = useState([]);

  const [changeNameClicked, setChangeNameClicked] = useState(false);

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'ruleGroup',
        route: 'ruleGroups/getRuleGroupById',
        ruleGroupId: rule_group_id,
      })
    );
    dispatch(apiAction({ reduxField: 'rules', route: 'rules/getRules' }));
  }, [dispatch, rule_group_id]);

  useEffect(() => {
    if (ruleGroup?._id) {
      setName(ruleGroup.name);
      setRuleIds(ruleGroup.ruleIds);
      setBlockRuns(ruleGroup.blockRuns);
    }
  }, [dispatch, ruleGroup]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedAddRules([]);
    setOpen(false);
  };

  const rulesColumns = [
    {
      field: '_id',
      headerName: 'ID',
      width: 225,
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 575,
      renderCell: (params) => (
        <a href={`/rule/${params.row._id}`} target='_blank' rel='noreferrer'>
          {params.value}
        </a>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 225,
      renderCell: (params) => (
        <>
          <span className={`text-${params.row.isActive ? 'success' : 'danger'}`}>
            {params.row.isActive ? 'Active' : 'Inactive'}
          </span>
        </>
      ),
    },
  ];

  const updateRuleGroupSingleField = (ruleGroupId, fieldName, newValue) => {
    dispatch(generalSet({ reduxField: 'loadingRuleGroup', value: true }));
    dispatch(
      apiAction({
        route: 'ruleGroups/updateRuleGroupSingleField',
        reduxField: 'ruleGroups',
        ruleGroupId,
        fieldName,
        newValue,
        setLoading: 'loadingRuleGroup',
      })
    );
    setChangeNameClicked(false);
  };

  const SaveButton = (props) => {
    const { ruleGroupId, fieldName, newValue } = props;
    return (
      <button
        className='btn btn-outline-dark'
        disabled={loadingRuleGroup}
        onClick={() => {
          updateRuleGroupSingleField(ruleGroupId, fieldName, newValue);
        }}
      >
        {loadingRuleGroup ? <Spinner /> : 'Save'}
      </button>
    );
  };

  console.log({ ruleGroup, ruleIds, blockRuns, rules, selectedAddRules });
  return ruleGroup?._id && Array.isArray(ruleIds) && Array.isArray(rules) ? (
    <>
      <div>
        <Link className='btn btn-outline-dark' to='/ruleGroups'>
          Back to Rule Groups
        </Link>
      </div>
      <div className='container mt-4 mb-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center border-bottom'>
          <h1>Edit Rule Group</h1>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          {changeNameClicked ? (
            <>
              <div className='col-md-5'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Rule group name...'
                  style={{ textAlign: 'center' }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              {ruleGroup.name !== name && <SaveButton ruleGroupId={ruleGroup._id} fieldName='name' newValue={name} />}
              <button
                className='btn btn-outline-secondary'
                onClick={() => {
                  setName(ruleGroup.name);
                  setChangeNameClicked(false);
                }}
              >
                Cancel
              </button>
            </>
          ) : (
            <>
              <h3 className='text-primary mr-2'>{name}</h3>
              <upper>
                <i title='Edit Name' className='fas fa-edit pointer' onClick={() => setChangeNameClicked(true)}></i>
              </upper>
            </>
          )}
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <button className='btn btn-outline-dark' onClick={() => handleOpen()}>
            Add Rules
          </button>
          {selectedRules.length > 0 ? (
            <button
              className='btn btn-outline-danger ml-2'
              disabled={loadingRuleGroup}
              onClick={() => {
                dispatch(
                  apiAction({
                    route: 'ruleGroups/removeRulesFromRuleGroup',
                    reduxField: 'ruleGroup',
                    ruleGroupId: ruleGroup._id,
                    ruleIds: selectedRules,
                    setLoading: 'loadingRuleGroup',
                  })
                );
                setSelectedRules([]);
              }}
            >
              Remove Rules
            </button>
          ) : null}
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 mt-2'>
          <Box style={{ height: 600, width: '100%' }}>
            <DataGrid
              rows={rules
                .filter((rule) => ruleIds.includes(rule._id))
                .map((rule) => {
                  return { id: rule._id, ...rule };
                })}
              columns={rulesColumns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              checkboxSelection
              onRowSelectionModelChange={(newSelection) => {
                setSelectedRules(newSelection);
              }}
              disableSelectionOnClick
            />
          </Box>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <h3>Block Runs</h3>
        </div>
        <div className='row d-flex justify-content-center'>
          <small>If enabled, all runs will be disabled from CRON</small>
        </div>
        <div className='row d-flex justify-content-center mt-2'>
          <button
            className={`btn btn-outline-${blockRuns ? 'primary' : 'secondary'}`}
            disabled={loadingRuleGroup}
            onClick={() => {
              updateRuleGroupSingleField(ruleGroup._id, 'blockRuns', !blockRuns);
              setBlockRuns(!blockRuns);
            }}
          >
            {blockRuns ? 'Enabled' : 'Disabled'}
          </button>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div
          className='modal-content'
          style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', outline: 'none', margin: '25%' }}
        >
          {selectedAddRules.length > 0 ? (
            <>
              <div className='row d-flex justify-content-center mb-2'>
                <button
                  className='btn btn-outline-success'
                  onClick={() => {
                    dispatch(
                      apiAction({
                        route: 'ruleGroups/addRulesToRuleGroup',
                        reduxField: 'ruleGroup',
                        ruleGroupId: ruleGroup._id,
                        ruleIds: selectedAddRules,
                        setLoading: 'loadingRuleGroup',
                      })
                    );
                    handleClose();
                  }}
                >
                  Add Rules
                </button>
              </div>
            </>
          ) : null}
          <div className='row d-flex justify-content-center pt-lg-0'>
            <Box style={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={rules.map((rule) => {
                  return { id: rule._id, ...rule };
                })}
                columns={rulesColumns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                checkboxSelection
                onRowSelectionModelChange={(newSelection) => {
                  setSelectedAddRules(newSelection);
                }}
                disableSelectionOnClick
              />
            </Box>
          </div>
        </div>
      </Modal>
    </>
  ) : (
    <Spinner />
  );
};

export default RuleGroup;
